export const INITIAL_STATE = {
    name: null,
    image_url: null,
    image_alt_text: null,
    sku: null,
    stock_quantity: null,
    weight: null,
    height: null,
    length: null,
    width: null,
    price: null,
    description: null,
}

export const GET_FIELD_NAME = {
    name: 'Nama gift',
    image_url: 'Foto gift',
    sku: 'Kode SKU',
    stock_quantity: 'Stok',
    price: 'Harga gift',
    weight: 'Berat',
}

export const FIELD_NAME_DETAIL = {
    ...GET_FIELD_NAME,
    image_alt_text: 'Alt text',
    height: 'Tinggi',
    length: 'Panjang',
    width: 'lebar',
    description: 'Deskripsi',
}
